import { render, staticRenderFns } from "./CreateEstimates.vue?vue&type=template&id=06484e62&scoped=true&"
import script from "./CreateEstimates.vue?vue&type=script&lang=js&"
export * from "./CreateEstimates.vue?vue&type=script&lang=js&"
import style0 from "./CreateEstimates.vue?vue&type=style&index=0&id=06484e62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06484e62",
  null
  
)

export default component.exports